import React, { useState } from "react";
import Subscription from "../../Public/Subscription";
import "./style.css";

const PricingPlan = () => {
  return (
    <div className="pricing-plan">
      <Subscription />
    </div>
  );
};

export default PricingPlan;
